import { NavLink } from "react-router";
import number_format from "../../utils/number_format";
import { PartnerApi } from "../../api/partner.api";
import { useTranslation } from "../../hooks/useTranslation";

export default function LoanRow({
                                       awailableColumns,
                                       selectedColumns,
                                       loan,
                                   }) {
    const { t } = useTranslation();
    return (
        <tr>
            {Object.keys(awailableColumns)
                .filter((awailableColumnsKey) =>
                    selectedColumns.includes(awailableColumnsKey)
                )
                .map((awailableColumnsKey) => (
                    <td
                        key={awailableColumnsKey}
                        className={
                            ["total_amount_currency"].includes(
                                awailableColumnsKey
                            ) && "text-end"
                        }
                    >
                        {["sent_pieces", "returned_pieces"].includes(
                            awailableColumnsKey
                        ) && loan[awailableColumnsKey]}

                        {"loan_id" == awailableColumnsKey && (
                            <>
                                <NavLink to={"/zapujcka/" + loan.loan_id}>
                                    {loan.loan_id}
                                </NavLink>
                            </>
                        )}
                        {["create_date", "loan_from", "loan_to"].includes(
                                awailableColumnsKey
                            ) &&
                            (loan[awailableColumnsKey] &&
                            loan[awailableColumnsKey] != "0000-00-00"
                                ? new Date(
                                    loan[awailableColumnsKey]
                                ).toLocaleDateString()
                                : "-")}

                        {"current_state" == awailableColumnsKey && (
                            <span
                                className={
                                    "badge badge-" +
                                    loan.current_state.state_style
                                }
                            >
                                  {loan.current_state.state_name}
                                </span>
                        )}

                        {"sales_person" == awailableColumnsKey && (
                            <>
                                {loan.sales_person.first_name}
                                &nbsp;
                                {loan.sales_person.last_name}
                            </>
                        )}

                        {"company" == awailableColumnsKey && (
                            <>{loan.company.name}</>
                        )}
                    </td>
                ))}

            <td className="text-end">
                <NavLink
                    to={"/zapujcka/" + loan.loan_id}
                    className="btn btn-primary"
                >
                    {t("common.detail")}
                </NavLink>
            </td>
        </tr>
    );
}
